"use client";

import WebLayout from "@/components/layout/web/WebLayout";
import CPageHeader from "@/components/main/CPageHeader";

const ServicesLayout = ({ children, servicesPageData, dictionary }) => {
  const items = [
    { title: dictionary.home, href: "/" },
    { title: servicesPageData?.landing?.title },
  ];
  return (
    <>
      <CPageHeader
        links={items}
        title={servicesPageData?.landing?.title}
        subTitle={servicesPageData?.landing?.description}
        showInput={false}
      />
      {children}
    </>
  );
};

export default WebLayout(ServicesLayout);
